import PropTypes from 'prop-types';

export const verificationPropTypes = {
	verification_id: PropTypes.string.isRequired,
	status: PropTypes.string.isRequired,
	created_timestamp: PropTypes.string.isRequired,
	total: PropTypes.number.isRequired,
	payments: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			amount: PropTypes.number.isRequired,
			source_account: PropTypes.string.isRequired,
			target_account: PropTypes.string.isRequired,
			source_account_name: PropTypes.string.isRequired,
			target_account_name: PropTypes.string.isRequired,
			reference: PropTypes.string,
			start_date: PropTypes.string,
			batch_name: PropTypes.string,
			creator_id: PropTypes.string,
			creator_name: PropTypes.string,
			approver: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					name: PropTypes.string.isRequired,
				})
			),
		})
	),
};
